import {SubscriptionTier} from './subscriptionFeatures'

// Every subscription SKU in App Store Connect's "Notability Subscription" group, grouped by the
// tier it sells. An App Store product id can't be renamed once created, so the prefixes keep the
// old tier names: light_* is Lite, premium_* is Plus, pro_* is Pro.
//
// This is the only list of them. A new SKU goes in one of these three, and everything that needs
// either the catalogue or a tier reads it from here.
const PRODUCT_IDS_BY_TIER = {
  [SubscriptionTier.light]: [
    'com.gingerlabs.Notability.light_subscription',
    'com.gingerlabs.Notability.light_subscription_3months',
    'com.gingerlabs.Notability.light_subscription_alt',
    'com.gingerlabs.Notability.light_subscription_monthly'
  ],
  [SubscriptionTier.premium]: [
    'com.gingerlabs.Notability.premium_subscription',
    'com.gingerlabs.Notability.premium_subscription_3months',
    'com.gingerlabs.Notability.premium_subscription_alt',
    'com.gingerlabs.Notability.premium_subscription_family',
    'com.gingerlabs.Notability.premium_subscription_monthly',
    'com.gingerlabs.Notability.premium_subscription_other',
    'com.gingerlabs.Notability.premium_subscription_variant'
  ],
  [SubscriptionTier.pro]: [
    'com.gingerlabs.Notability.pro_subscription',
    'com.gingerlabs.Notability.pro_subscription_3months',
    'com.gingerlabs.Notability.pro_subscription_alt',
    'com.gingerlabs.Notability.pro_subscription_monthly',
    'com.gingerlabs.Notability.pro_subscription_monthly_alt'
  ]
} as const satisfies Partial<Record<SubscriptionTier, readonly string[]>>

export const APPLE_SUBSCRIPTION_PRODUCT_IDS = Object.values(PRODUCT_IDS_BY_TIER).flat()

const TIER_BY_PRODUCT_ID = new Map<string, SubscriptionTier>(
  Object.entries(PRODUCT_IDS_BY_TIER).flatMap(([tier, productIds]) =>
    productIds.map((productId): [string, SubscriptionTier] => [productId, tier as SubscriptionTier])
  )
)

// Anything unrecognised reads as Plus, which is what receipt handling has always assumed: a SKU
// added to App Store Connect without a code change is far more likely to be a Plus variant than a
// tier nobody has named here.
export function appleProductTier(productId: string): SubscriptionTier {
  return TIER_BY_PRODUCT_ID.get(productId) ?? SubscriptionTier.premium
}
